import { callAPI, callAPIWhiteToken } from "../config/api";

const PATH_API = process.env.REACT_APP_API;

export async function postDataPages(data: any) {
  const url = `${PATH_API}/learning/filtered`;
  return await callAPIWhiteToken({
    url,
    method: "POST",
    data: data,
  });
}

export async function postDataPagesNoToken(data: any) {
  const url = `${PATH_API}/learning/filtered`;
  return await callAPI({
    url,
    method: "POST",
    data: data,
  });
}

export async function getDataDetail(slug: string) {
  const url = `${PATH_API}/learning/detail/${slug}`;
  return await callAPIWhiteToken({
    url,
    method: "GET",
  });
}
